import { createAction, props } from '@ngrx/store';

import { SearchAllCategory, SearchCategoryPagination } from 'SearchApp/ts/types/search-all-category.type';

export const changeSearchTypes = createAction(
    '[Search All Page] Set Search Types',
    props<{
        searchTypes: SearchAllCategory[];
    }>()
);

export const changeQueryInput = createAction(
    '[Search All Page] Change Query Input',
    props<{
        queryInput: string;
    }>()
);

export const searchChangeCategoryPageNum = createAction(
    '[Search All Page] Change Category Page Num',
    props<{
        searchCategoryPageNum: SearchCategoryPagination;
    }>()
);
